import ChecklistIcon from '../ChecklistIcon/ChecklistIcon'
import { WHITE } from '../../styles/colors'
import { ValueText, CheckContainer, DashText } from './KYCBenefitValue.styles'

const toCurrencyFormat = (num: number) => Number(Number(num).toFixed(0)).toLocaleString('id-ID')

const KYCBenefitValue = ({
    value,
    unit,
    unitPosition,
    isCurrency
}: {
    value: string | boolean | number
    unit?: string
    unitPosition?: 'left' | 'right'
    isCurrency?: boolean
}) => {
    switch (typeof value) {
        case 'number':
            if (unit) {
                if (unitPosition === 'left') {
                    return (
                        <ValueText>
                            {unit && <span>{unit}</span>}
                            {isCurrency ? <span>{toCurrencyFormat(value)}</span> : <span>{value}</span>}
                        </ValueText>
                    )
                } else {
                    return (
                        <ValueText>
                            {isCurrency ? <span>{toCurrencyFormat(value)}</span> : <span>{value}</span>}
                            {unit && <span>{unit}</span>}
                        </ValueText>
                    )
                }
            } else {
                return (
                    <ValueText>
                        {value}
                    </ValueText>
                )
            }
        case 'boolean':
            return (
                <div>
                    {value ?
                    <CheckContainer>
                        <ChecklistIcon color={WHITE} size={8} strokeWidth={2} />
                    </CheckContainer>
                        :
                    <DashText>
                        -
                    </DashText>
                    }
                </div>
            )
    }
}

export default KYCBenefitValue
